import React, { useEffect, useState } from 'react';
import { postData } from '../../../../../api/componentAPIs';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import { Button, withStyles } from '@material-ui/core';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import { getAdditionalDataPayload, getCombinedData } from './utills';
import CustomerData from './components/CustomerData';

const styles = (theme) => ({
  container: {
    width: '100%',
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  actionButton: {
    display: 'flex',
    width: 140,
    textTransform: 'none',
    alignSelf: 'flex-end',
    '&$actionDisabled, &$actionDisabled:hover': {
      cursor: 'not-allowed',
      pointerEvents: 'all',
      backgroundColor: 'transparent',
      opacity: 0.7,
      color: theme.TextColor,
      border: `1px solid ${theme.iconColor}`
    }
  },
  actionDisabled: {},
  shipmentsListContainer: {
    flex: 1,
    overflowY: 'auto'
  }
});

const ShipmentDetails = ({
  classes,
  selectedStops,
  mergeStopInProgress,
  mergeType,
  onClose,
  enqueueSnackbar,
  userData
}) => {
  const [data, setData] = useState(null);
  const scenarioId = userData?.userProfile?.scenarioID;
  useEffect(() => {
    getShipmentsData();
  }, []);

  const getShipmentsData = () => {
    const payLoad = getAdditionalDataPayload(selectedStops, mergeType, scenarioId);
    postData('GetDuplicateCustomerAdditionalDetails', payLoad).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        const combinedData = getCombinedData(selectedStops, mergeType, response.data);
        setData(combinedData);
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      }
    });
  };

  return (
    <div className={classes.container}>
      <div className={`${classes.shipmentsListContainer} customScroll`}>
        {data?.map((details, index) => (
          <CustomerData key={index} data={details} />
        ))}
      </div>
      <Button
        variant="outlined"
        color="primary"
        classes={{
          root: classes.actionButton,
          disabled: classes.actionDisabled
        }}
        onClick={onClose}
        disabled={mergeStopInProgress}>
        Cancel
      </Button>
    </div>
  );
};

export default compose(withSnackbar, withUserProfile, withStyles(styles))(ShipmentDetails);
